// extracted by mini-css-extract-plugin
export default {"root":"SimilarListings_root__pdUoh","heading":"SimilarListings_heading__612P8 textHeadingSm","grid":"SimilarListings_grid__wUBnF","cardWrapper":"SimilarListings_cardWrapper__1ewYI"};